<template>
	<el-dialog title="Perfil" width="500px" :visible.sync="show" @close="onClosed">
		<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="85px">
			<el-form-item label="Nombre" prop="first_name">
				<el-input v-model="ruleForm.first_name"></el-input>
			</el-form-item>
			<el-form-item label="Apellido" prop="last_name">
				<el-input v-model="ruleForm.last_name"></el-input>
			</el-form-item>
			<br />
			<el-divider content-position="left">Gestión de contraseña</el-divider>
			<el-form-item label="Contraseña Actual" prop="actPass" label-width="135px">
				<el-input type="password" v-model="ruleForm.actPass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="Contraseña Nueva" prop="pass" label-width="135px">
				<el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="Repita Contraseña" prop="checkPass" label-width="135px">
				<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" style="display: flex; justify-content: space-between;">
			<el-button @click="show = false">Cerrar</el-button>
			<el-button type="primary" :loading="guardando" @click="onSubmit">Guardar</el-button>
		</span>
	</el-dialog>
</template>
<script lang="js">
export default {
	name: 'perfil',
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		var validatePass = (rule, value, callback) => {
			if (value.length < 6 && value !== '')
				callback(new Error('Mínimo 6 caracteres'));
			 else if (this.ruleForm.checkPass !== '')
				this.$refs.ruleForm.validateField('checkPass');

			callback();
		};
		var validatePass2 = (rule, value, callback) => {
			if (value !== this.ruleForm.pass)
				callback(new Error('Las contraseñas no coinciden'));
			 else
				callback();

		};
		return {
			show: false,
			guardando: false,
			ruleForm: {
				first_name: '',
				last_name: '',
				pass: '',
				checkPass: '',
				actPass: '',
			},
			rules: {
				first_name: [{ required: true, message: 'El nombre no puede ser vacío.', trigger: 'blur' }],
				last_name: [{ required: true, message: 'El apellido no puede ser vacío.', trigger: 'blur' }],
				pass: [{ validator: validatePass, trigger: 'blur' }],
				checkPass: [{ validator: validatePass2, trigger: 'blur' }],
			},
		};
	},
	watch: {
		visible(v) {
			this.show = v;
		},
		userdata(v) {
			this.ruleForm.first_name = v.first_name;
			this.ruleForm.last_name = v.last_name;
		},
	},
	computed: {
		userdata() {
			return this.$store.state.perfil.userdata;
		},
	},
	methods: {
		onSubmit() {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					this.guardando = true;
					let params = {
						url: './api/public/data',
						data: this.$refs['ruleForm'].model,
					};
					this.$store.dispatch('setPerfil', params).then(response => {
						if (!response.data.success) {
							this.$message({
								type: 'error',
								message: response.data.msg,
							});
						} else {
							this.$message({
								type: 'success',
								message: response.data.msg,
							});
							this.$store.state.perfil.userdata.first_name = response.data.first_name;
							this.$store.state.perfil.userdata.last_name = response.data.last_name;
							this.sm = false;
						}
						this.guardando = false;
						this.$emit('closed');
					});
				} else {
					this.guardando = false;
					console.log('Error submit!!');
					return false;
				}
			});
		},
		onClosed() {
			this.$refs['ruleForm'].resetFields();
			this.$emit('closed');
		},
	},
};
</script>
<style></style>
